import React, { useState , useEffect } from "react";
import { connect } from "react-redux";
import { Link, Redirect , NavLink, useHistory } from "react-router-dom";
import { setAlert } from "../../actions/alert";
import PropTypes from "prop-types";
import { Carousel } from 'react-responsive-carousel';
import Dropdown from 'react-bootstrap/Dropdown';
import {SVGSearchMagnifine, SVGArrowDown, SVGArrowLeftSilck, SVGArrowRightSilck} from "../SVG";
import Services from '../Services/services';
import Search from "./search";
import { skillsGet } from "../../actions/clientProfile";

import backgroundImage1 from './slider-1.jpeg';
import backgroundImage2 from './2.jpeg';
import backgroundImage3 from './slider-3.png';

const sliderContent = [
  {
    image: backgroundImage1,
    heading1: 'Protect your digital world by verified & trustworthy',
    heading2: 'cybersecurity professionals',
    heading3: 'Search + Hire = ',
    heading4: 'Work done!'
  },
  {
    image: backgroundImage2,
    heading1: 'Post your project and get it done by a top-rated ',
    heading2: 'cybersecurity professional',
    heading3: 'Best talent pool = ',
    heading4: 'Best outcome',
  },
  {
    image: backgroundImage3,
    heading1: 'Want to offer your services? Join as a ',
    heading2: 'cybersecurity professional',
    heading3: 'Build your profile + Provide a service = ',
    heading4: 'Make extra money'
  },
];


const MainSlider = ({auth: { isAuthenticated, user }, clientProfile: { skills }, skillsGet}) => {
  const [searchLocation, setSearchLocation] = useState('Talent');
  const history = useHistory();
  const [value, setValue] = useState('');
  const [indicator, setIndicator] = useState(true);

  const handleLinkClick = (e) => {
    e.preventDefault(); // Prevent default link behavior
    setValue(e.target.innerText);
  };

  useEffect(() => {
    skillsGet();
  }, []);

  
  const Search_input = () => {
    localStorage.setItem('search', JSON.stringify(value));
    if(searchLocation === "Talent"){
      history.push(`/talent?value=${value}`);
    }else{
      history.push(`/job?value=${value}`);
    }
    
  }

  return (
    <section className="main-slider">
        <Carousel
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              <button
                type="button"
                className={"control-arrow control-prev"}
                onClick={onClickHandler}
              >
                <SVGArrowLeftSilck />
              </button>
            )
          }
          renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
              <button
                type="button"
                className={"control-arrow control-next"}
                onClick={onClickHandler}
              >
                <SVGArrowRightSilck />
              </button>
            )
          }
          showArrows={true}
          showStatus={false}
          showThumbs={false}
          infiniteLoop={true}
          showIndicators={indicator}
          autoPlay={true}
          interval={5000}
        >
          
          {sliderContent.map((slide, index) => (
            <div
              key={index}
              className="mainSlider"
              style={{
                backgroundImage: `url(${slide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center"
              }}
            >
              
            <div className="mainSlider mainSlider-One">
            <div className="container">
                        <div>
                            <hgroup className="homepage-search-headings">
                                <h2 className="heading-h1" style={{fontWeight: "200"}}>{slide.heading1} <strong style={{fontWeight: "650" }}>{slide.heading2}</strong></h2>
                               
                                <h2 className="heading-h2" style={{marginTop:"-10px" , fontWeight: "200"}}>{slide.heading3} <strong style={{fontWeight: "1000" , fontFamily:"Inter"}}>{slide.heading4}</strong></h2>
                            </hgroup>
                            <div className="homepage-search-form">
                                <form className="form-noborder">
                                    <div className="form-row row">
                                        <div className="col-lg-3 col-md-3 col-xs-12">
                                        <div className="search-location-dropdown">
                                            {/* <i className="icofont-location-arrow"></i> */}
                                            <Dropdown >
                                                <Dropdown.Toggle id="dropdown-basic" variant="default">
                                                    <span style={{ fontSize: "14px" , color:"#01131D"}}>{searchLocation}</span> <SVGArrowDown/>
                                                </Dropdown.Toggle>

                                                {user.type === 'Freelancer' || !isAuthenticated ? 
                                                <Dropdown.Menu>
                                                    <Dropdown.Item eventKey="1" onClick={()=>setSearchLocation('Talent')}>Talent</Dropdown.Item>
                                                    <Dropdown.Item eventKey="2" onClick={()=>setSearchLocation('Job')}>Job</Dropdown.Item>
                                                  
                                                </Dropdown.Menu>
                                                :console.log('')}
                                            </Dropdown>
                                            
                                        </div></div>

                                        <div className="col-lg-7 col-md-6 col-xs-12">
                                        <div className="search-input">
                                          {console.log(value)}
                                            <SVGSearchMagnifine/>
                                            {/** <input type="text" value={value} onChange={e => setValue(e.target.value)}  placeholder="Find Services..." className="form-control border-0 form-control-lg" style={{ fontSize: "14px" , color:"#01131D"}}/>*/}
                                            <Search
                                            suggestions={skills.length > 0 ? skills.map(item => item.skill_name) : []}
                                            setInput={setValue}
                                            setIndicator={setIndicator}
                                            pre_value={value} 
                                            />
                                        </div>
                                        </div>

                                        <div className="col-lg-2 col-md-3 col-xs-12">
                                        <div className="search-btn">
                                            <button type="submit" className="btn btn-block btn-primary p-0"  style={{backgroundColor: "#01131d", color: "white"}} onClick= {Search_input}>
                                                Search
                                            </button>
                                        </div>
                                        </div>

                                    </div>
                                </form>
                            </div>
                            <div className="popular">
                                <span className="popular-heading" style={{color: "#01131d", fontSize: "1rem"}}>Popular:</span>
                                <ul>
                                    <li><a href="#" onClick={handleLinkClick}>Network Security</a></li>
                                    <li><a href="#" onClick={handleLinkClick}>Cyber Risk Management</a></li>
                                    <li><a href="#" onClick={handleLinkClick}>Malware Protection</a></li>
                                    <li><a href="#" onClick={handleLinkClick}>Data Security</a></li>
                                    <li><a href="#" onClick={handleLinkClick}>Penetration Testing</a></li>
                                  </ul>
                            </div>
                        </div>
                    </div>
            </div>
            </div>
          ))}
        </Carousel> 
    </section>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  clientProfile: state.clientProfile,
});



export default connect(mapStateToProps,{skillsGet})(MainSlider);